import { EnvironmentProviders, inject, makeEnvironmentProviders, Provider } from '@angular/core';
import { getApp } from '@angular/fire/app';
import {
	browserLocalPersistence,
	browserPopupRedirectResolver,
	browserSessionPersistence,
	connectAuthEmulator,
	initializeAuth,
	provideAuth
} from '@angular/fire/auth';
import { Capacitor } from '@capacitor/core';
import { NovaPortalLibConfigService } from '@nova-portal/frontend-lib';

const providePersistence = () => {
	return Capacitor.getPlatform() === 'web' ? browserSessionPersistence : browserLocalPersistence;
};

export const authProviders: (Provider | EnvironmentProviders)[] = [
	provideAuth(() => {
		const auth = initializeAuth(getApp(), {
			persistence: providePersistence(),
			popupRedirectResolver: Capacitor.isNativePlatform() ? undefined : browserPopupRedirectResolver
		});
		const config = inject(NovaPortalLibConfigService).getConfig();
		if (config.useFunctionsEmulator) {
			console.log('Use Auth Emulator');
			connectAuthEmulator(auth, 'http://localhost:9099', {
				disableWarnings: true
			});
		}
		return auth;
	})
];

/**
 * Provides Firebase authentication for standalone applications.
 * @returns Environment providers for Firebase authentication.
 */
export const provideNovaPortalAuth = (): EnvironmentProviders => makeEnvironmentProviders(authProviders);
